/* 人教版大纲每单元的单元知识 */
/* Author: renwanfeng */
/* create:2021/06/16 */
<template>
  <div class="flex-center flex-column mainbody">
    <!--标题 -->
    <div id="header">
      <div class="header-title-word"><span style="fontSize: 20px">{{user_name}}的单元知识复习</span>  
      </div>
      <div class="bg"><img src="../../../../static/images/PeasonalizedTarget-background.png"></div>
    </div>

    <!--引入语 -->
    <div class="text-border-panel">
      <div class="maintext">
        <p v-if="unit_name" class="flex-row-center orange-bold" style="fontSize: 18px" v-html="unit_name"></p>
        <div v-if="tips == ''">
          恭喜{{user_name}}宝贝完成了本单元的学习，这个单元的重点知识（包含核心词汇、核心句子和核心语法）都可以点进深度学习的页面，
          单词学习页面可以重点看图听音听双语例句，句子听对话理解意思，语法可以查看语法视频来巩固。通过这个可以全方位的提升咱们宝贝这学期的知识掌握。快来一起复习吧！
        </div>
        <div v-if="tips" style="text-indent: 2px;font-size: 15px" v-html="addDiv(tips)"/>
      </div>
      <!-- </div>

  <div id="resource"> -->
      <!--单词 key_word-->
      <div class="resource_cartoon"
           v-if="key_word.length>0">
        <p>
          <span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>核心词汇:</strong>
          </span>
        </p>
        <div class="word-img-row">
          <div class="word-div"
               v-for="word in key_word"
               :key="word">
            <a class="word-href"
               :href="'/resource/word_v2/' + word.id_cipher + tailUrl"
               @click="content_href_learning('word',word.uuid)">
              <img class="word-img"
                   v-if="level == '-1' && word.word_picture_link_levelk != ''"
                   :src="word.word_picture_link_levelk"/>
              <img class="word-img"
                   v-else-if="word.word_picture_link"
                   :src="word.word_picture_link"/>
              <img class="word-img"
                   v-else
                   src="http://s.kg.51talkjr.com/85703bb4-c163-45f5-9f60-f208cda0d9d0.jpeg"/>
              <div class="word-img-div">
                <div class="word-sound-img">
                  <i v-if="word.cej_ph_en"
                     class="word-sound"
                     @click.stop.prevent="sound_custom(word.cej_ph_en,'word',word.uuid)"></i>
                </div>
              </div>
              <div class="word-text-div"
                   v-bind:style="{fontSize: changeFontSize(word.word_name) + 'px'}">
                <span v-if="word.is_wrong == 1"
                      class="orange-bold">{{word.word_name}}
                </span>
                <span v-else
                      class="blue-bold">{{word.word_name}}
                </span>
              </div>
            </a>
           </div>
        </div>
      </div>

      <!--核心句子 sentence-->
      <div class="resource_book"
           v-if="sentence.length>0">
        <p><span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>核心句子:</strong></span>
        </p>

        <div class="maintext">
          <div class="p-container"
               v-for="(item,i) in sentence"
               :key="i">
            <p class="p-english family-english size-english">
              <span class="p-order">{{i+1}}.</span>
              <a :href="'/resource/sentence/' + item.id_cipher + tailUrl"
                 @click="content_href_learning('sentence',item.uuid)">
                <span v-if='item.is_wrong==1'
                      class="orange-bold">{{item.sentence_en}}</span>
                <span v-else
                      class="blue-bold">{{item.sentence_en}}</span>
              </a>
              <!-- :data-analytics='`{"action":"CK_UNIT_KNOWLEDGE_SENTENCE_SOUND","type":"sentence","id": ${item.id}}`' -->
              <i v-if="item.sentence_en_mp3"
                 class="word-sound"
                 @click.stop.prevent="sound_custom(item.sentence_en_mp3,'sentence',item.uuid)"></i>
            </p>
            <p class="sentence-answer"
               v-if="item.sentence_en_answer != null">{{item.sentence_en_answer}}
              <!-- style="color: RGB(27, 70, 125)"  p-chinese family-chinese size-chinese  -->
              <!-- <span v-text="item.sentence_en_answer"></span> -->
              <i v-if="item.sentence_en_answer_mp3"
                 class="word-sound"
                 @click.stop.prevent="sound_custom(item.sentence_en_answer_mp3,'sentence',item.uuid)"></i>
            </p>
          </div>
        </div>
      </div>

      <!--语法 grammar_level-->
      <div class="resource_activity"
           v-if="grammar_level.length>0">
        <p>
          <span class="resource-title">
            <span class="fa fa-star"></span>
            <strong>核心语法点:</strong>
          </span>
        </p>

        <div class="maintext">
          <div class="p-container"
               v-for="(item,k) in grammar_level"
               :key="k">
            <p class="p-english family-english size-english">
              <a :href="'/resource/grammar/' + item.id_cipher + tailUrl"
                 @click="content_href_learning('grammar',item.uuid)">
                <span v-if="item.is_wrong == 1"
                      class="orange-bold">
                  <span class="p-order">{{k+1}}.</span> {{item.grammar_level_en}}({{item.grammar_level}})
                </span>
                <span v-else
                      class="blue-bold">
                  <span class="p-order">{{k+1}}.</span> {{item.grammar_level_en}}({{item.grammar_level}})
                </span>
              </a>
            </p>
          </div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>
import BaseVue from '@/components/BaseVue'
require('@/assets/css/peasonalized-target.css')
var unitData = require('../mock/unit')

export default {
  name: 'UnitKnowledgeReview',
  extends: BaseVue,
  data() {
    return {
        tips: '',
        grade: '',
        seminar: '',
        user_name: '',
        unit_name:'',
        url_params: '',
        user_id: '0',
        unit_id: '0',
        unit_idx: '',
        level: '-1',
        key_word: [],
        sentence: [],
        grammar_level: [],
        sig:'',
        adminid: 123
    }
  },
  computed: {
    tailUrl: function () {
      return this.url_params === '' ? '' : '?' + this.url_params
    },
  },
  created: function () {
    this.unit_id = this.$route.query.unitid
    this.unit_idx = parseInt(this.$route.query.unit_idx) + 1
    this.grade = this.$route.query.grade
    this.seminar = this.$route.query.seminar
    this.user_id = this.$route.query.uid
    this.sig = this.$route.query.sig
    this.user_name = this.$route.query.u_name
    // let use_sig = this.$route.query.use_sig
    // this.level = this.$route.query.level
    // this.type = this.getUrlParam('type')
    // this.user_name = this.getUrlParam('u_name')
    // var unitdata = new unitData()
    // this.Data = unitdata.data

    // let use_sig = 1
    // this.user_id = this.$route.query.uid
    // this.unit_id = this.$route.query.unitid
    // if (user_id === undefined || unit_id === undefined) return
    // let realSig = this.generateSig(user_id + unit_id)
    // if (!this.checkSig(user_id + unit_id, sig)) return
    // 支持调试和前端上线的sig验证模式
    // if (use_sig != undefined) {
    //   var url =
    //     this.UNIT_KNOWLEDGE_API +
    //     'cej_unit_mastery?uid=' +
    //     user_id +
    //     '&unitid=' +
    //     unit_id +
    //     '&use_sig=0'
    // } else {
    //   var url =
    //     this.UNIT_KNOWLEDGE_API +
    //     'cej_unit_mastery?uid=' +
    //     user_id +
    //     '&unitid=' +
    //     unit_id +
    //     '&sig=' +
    //     sig
    // }
    let url = this.APIHOST + `pep_unit_details?semester=${this.seminar}&grade=${this.grade}&unit_idx=${this.unit_idx}` //test mode
    // let url = `http://10.0.2.70:8033/api/cms/pep_unit_details?semester=${this.seminar}&grade=${this.grade}&unit_idx=${parseInt(this.unit_idx)+1}` //test mode
    fetch(url, {
        method: "get",
        mode: "cors",
      }).then((res) => res.json())
        .then((data) => {
          if(data.error_code == 10000){
            this.unit_name = data.ret.unit_name
            this.key_word = data.ret.key_word
            this.sentence = data.ret.sentence
            this.grammar_level =  data.ret.grammar_level
          }
          else{
            this.tips ='<p>对不起啦，本单元的单元知识还没找到！看看您是不是不小心调到别的单元啦！这学期咱们只有1-6个单元哟!</p>'
            console.log(this.tips)
          }
        }
      )
    // this.url_params = this.$route.fullPath.split('?')[1]
    // console.log(this.url_params)
    // this.type = this.$route.query.type
    // let that = this
    // 增加人教版单元知识埋点
    pindData.add_params({ t: 'FRR.000001' })
    pindData.pind_send( {
      "action": "PG_FINAL_REVIEW_REPORT_UNIT", 
      "user_id": this.user_id,
      "seminar": this.seminar,
      "grade": this.grade,
      "unit_index": this.unit_idx
      } );
  },
  methods: {
    changeFontSize: function (word_name) {
      //9*15 = word_name.length * X
      if (word_name.length > 9) return parseInt((9 * 15) / word_name.length)
    },
    sound: function (url) {
      var audio = new Audio(url)
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
    },
    sound_custom: function (url, type,id) {
      var audio = new Audio(url)
      audio.play() //autoplay自动播放 loop循环播放  pause暂停
      //点击单元知识掌握报告页面某个知识的发音（目前只有单词、自然拼读和句子)
      let action ='CK_FINAL_REVIEW_REPORT_UNIT_' + type.toLocaleUpperCase() + '_SOUND'
      pindData.pind_send({
        action: action,
        grade: this.grade,
        unit_index: this.unit_idx,
        seminar: this.seminar,
        user_id: this.user_id,
        uuid: id //知识id
      })
    },
    content_href_learning: function (type,id) {
      //点击人教版单元知识的超链子页面学习（单词、句子、语法）
      let action = 'CK_FINAL_REVIEW_REPORT_UNIT_' + type.toLocaleUpperCase()
      pindData.pind_send({
        action: action,
        type: type,
        grade: this.grade,
        uuid: id, //知识id
        unit_index: this.unit_idx,
        seminar: this.seminar,
        user_id: this.user_id
      })
    },
    getUrlParam(name) {
      //a标签跳转获取参数
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      var r = window.location.search.substr(1).match(reg)
    //   console.log(window.location.search)
    //   console.log(r)
      if (r != null) return r[2]
      return null
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/template/target/UnitKnowleageReview.vue